import countNumbers from './count-numbers';

export default function areNumbers(values) {
    return countNumbers(values) === values.length;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/chart/utils/are-numbers.js
// module id = 545
// module chunks = 29